import React from "react";
import { Button, SearchBar, Typography } from "@kitbird/core";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import {
  CardContent, PageCard, PageWrapper, TitleContent,
} from "../../../components/Content/Content.style";
import { HeaderText } from "../../../components/FloatHeader/FloatHeader.style";
import BluebirdLogo from "../../../assets/icons/logogram_bb.png";
import { ActionSection } from "../../../components/Filter/Filter.style";
import { StickyTable } from "../../../components/Table/Table.style";
import DepartmentTable from "./components/DepartmentTable";
import ModalDepartmentForm from "./components/DepartmentFormModal";
import ModalDepartmentDelete from "./components/DepartmentDeleteModal";
import useDepartment from "./useDepartment";
import PageLoading from "../../../components/Loading/PageLoading";

const Department = () => {
  const useCustomHook = useDepartment();
  const {
    isLoading,
    modalFormDepartment,
    setModalFormDepartment,
    modalDeleteDepartment,
    setModalDeleteDepartment,
    editValues,
    setEditValues,
    setParams,
  } = useCustomHook;

  return (<>
    <PageWrapper>
      <HeaderText>
        <Typography level={3} fontWeight="medium">Master departemen</Typography>
      </HeaderText>
      <PageCard>
        <CardContent>
          <TitleContent>
            <img src={BluebirdLogo} alt="" />
            <Typography level={4} fontWeight="medium">
              Daftar departemen
            </Typography>
          </TitleContent>
          <ActionSection>
            <SearchBar onInputSearch={(val) => setParams((curr) => ({ ...curr, search: val }))} hasReset placeholder="Cari data" />
            <Button
              onClick={() => setModalFormDepartment(true)}
              leftIcon={<PlusIcon />}
            >
              Tambah data
            </Button>
          </ActionSection>
          <StickyTable>
            <DepartmentTable
              showModal={() => setModalFormDepartment(true)}
              showDeleteModal={() => setModalDeleteDepartment(true)}
              setEditValue={setEditValues}
              useCustomHook={useCustomHook}
            />
          </StickyTable>
        </CardContent>
      </PageCard>
      <ModalDepartmentForm
        isOpen={modalFormDepartment}
        value={editValues}
        setClose={(modalState) => {
          setModalFormDepartment(modalState);
          setEditValues(undefined);
        }}
        useCustomHook={useCustomHook}
      />
      <ModalDepartmentDelete
        isOpen={modalDeleteDepartment}
        value={editValues}
        setClose={(modalState) => {
          setModalDeleteDepartment(modalState);
          setEditValues(undefined);
        }}
        useCustomHook={useCustomHook}
      />
    </PageWrapper>
    {isLoading && (
      <PageLoading />
    )}
  </>);
};

export default Department;
